import React, { useState, useEffect } from 'react';
import { Dialog, AppBar, Toolbar, Tabs, Tab, Box, Typography } from '@mui/material';
import { CircularProgress } from '@material-ui/core';
import axios from 'axios';
import { toast } from 'react-toastify';
import { generateForm } from '../helpers/functions';
import JobDetailsTab from './JobTabs/JobDetailsTab';
import StatusTab from './JobTabs/StatusTab';
import PaymentsTab from './JobTabs/PaymentsTab';

const JobUpdateModal = ({ 
  open, 
  onClose, 
  jobId, 
  onSuccess,
  venders,
  customers,
  jobTypes
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [jobData, setJobData] = useState(null);

  // Determine if this is add or update mode
  const isAddMode = jobId === -1;
  const isUpdateMode = jobId > 0;

  useEffect(() => {
    if (open) {
      if (isUpdateMode) {
        // Update mode - load job data
        loadJobData();
      } else if (isAddMode) {
        // Add mode - clear job data
        setJobData(null);
      }
    }
  }, [open, jobId]);

  const loadJobData = () => {
    setLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/admin/jobs/getById/${jobId}`,
    })
      .then((response) => {
        setJobData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(`Error loading job data`);
        setLoading(false);
      });
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleClose = () => {
    setActiveTab(0);
    setJobData(null); // Clear job data when modal closes
    onClose();
  };

  const handleSuccess = () => {
    // Close the modal
    handleClose();
    
    // Call the parent's onSuccess callback if provided
    if (onSuccess) {
      onSuccess();
    }
  };

  if (loading) {
    return (
      <Dialog fullScreen open={open} onClose={handleClose}>
        <AppBar className="position-relative">
          <Toolbar>
            <button type="button" className="close-modal-button" onClick={handleClose}>
              &times;
            </button>
            <h4 className="text-white mx-3 my-0">Loading...</h4>
          </Toolbar>
        </AppBar>
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress />
        </Box>
      </Dialog>
    );
  }

  return (
    <Dialog fullScreen open={open} onClose={handleClose} style={{ zIndex: 2235 }}>
      <AppBar className="position-relative">
        <Toolbar>
          <button type="button" className="close-modal-button" onClick={handleClose}>
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">
            {isAddMode ? "Add New Job" : "Update Job"}
          </h4>
        </Toolbar>
      </AppBar>

      <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={handleTabChange} aria-label="job update tabs">
            <Tab label="Job Details" />
            <Tab label="Status" />
            <Tab label="Payments" />
          </Tabs>
        </Box>

        <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
          {activeTab === 0 && (
            <JobDetailsTab 
              jobData={jobData}
              venders={venders}
              customers={customers}
              jobTypes={jobTypes}
              onSuccess={handleSuccess}
            />
          )}
          {activeTab === 1 && (
            <StatusTab 
              jobId={jobId}
              onSuccess={handleSuccess}
            />
          )}
          {activeTab === 2 && (
            <PaymentsTab 
              jobId={jobId}
              onSuccess={handleSuccess}
            />
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default JobUpdateModal; 